// extracted by mini-css-extract-plugin
export default {"grayish-row":"styles_grayish-row__sbjjC","support-view":"styles_support-view__O6AeK"};